<script lang="ts">
  // components
  import UIRouterLink from "@shared/svelte/Components/UIRouterLink.svelte";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import FizzStyles from "@shared/svelte/Components/FizzStyles.svelte";
  import ProviPayCard from "@retailer/svelte/Payments/ProviPayCard.svelte";

  import layoutStore from "@shared/svelte/Stores/LayoutStore";

  // props
  export let heading: string = "Invoices";
  export let backLink: string = null;
  export let backLinkParams: { [key: string]: any } = {};

</script>

<FizzStyles>
  <div
    class="fizz-container background-white fizz-border-bottom fizz-space-between fizz-inset-vertical-16"
    class:fizz-inset-square-16={$layoutStore.isMobile}
    class:fizz-inset-horizontal-32={$layoutStore.isDesktop}
  >
    <div class="fizz-flex-item fizz-space-between-responsive">
      <ProviPayCard extraClassNames={"fizz-hide-on-large fizz-stack-16"} />
      <div class="fizz-stack-0">
        {#if backLink}
          <UIRouterLink stateName={backLink} params={backLinkParams}>
            <Icon extraClassNames="fizz-text-brand" type="ArrowLeft" height="12" width="12" />
          </UIRouterLink>
        {/if}
        <h4 class="fizz-heading-4" data-testid="invoices-breadcrumb">{heading}</h4>
      </div>
      <ProviPayCard extraClassNames={"fizz-hide-on-small"} />
    </div>
  </div>
</FizzStyles>
